module.exports = __webpack_public_path__ + "static/media/morningEps.8bbcd675.svg";